const STORAGE_KEY = 'hcen_platform_user';
const TOKEN_KEY = 'hcen_platform_token';

/** Platform admin sessions stay signed in for 1 year (like OP — no frequent expiry). */
export const PLATFORM_SESSION_MS = 365 * 24 * 60 * 60 * 1000;

function base64UrlDecode(part) {
  let s = part.replace(/-/g, '+').replace(/_/g, '/');
  const pad = s.length % 4;
  if (pad) s += '='.repeat(4 - pad);
  return atob(s);
}

function decodeCustomToken(token) {
  const parts = token.split('.');
  if (parts.length !== 2) return null;
  try {
    return JSON.parse(base64UrlDecode(parts[0]));
  } catch {
    return null;
  }
}

export function hasValidPlatformSession() {
  const token = localStorage.getItem(TOKEN_KEY);
  const user = localStorage.getItem(STORAGE_KEY);
  if (!token || !user) return false;

  const data = decodeCustomToken(token);
  if (!data || data.portal !== 'networks-platform') return false;
  if (data.exp && Date.now() > data.exp) return false;
  return true;
}

export function clearPlatformSession() {
  localStorage.removeItem(STORAGE_KEY);
  localStorage.removeItem(TOKEN_KEY);
}

export function getPlatformTokenExpiryMs() {
  const token = localStorage.getItem(TOKEN_KEY);
  if (!token) return 0;
  const data = decodeCustomToken(token);
  return data?.exp || 0;
}

export { STORAGE_KEY, TOKEN_KEY };
